export { default } from './SectionFooter';
